<template>
  <b-card class="shadow" style="min-height: 700px" ref="printMe">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between mb-4">
          <h1 class="h3 mb-0 text-gray-800">
            {{ $t("SCFV: Gráficos") }}
          </h1>
          <b-button-group>
            <b-button
              variant="outline-dark"
              :class="viewFilterReport === true ? 'active' : ''"
              @click="viewFilters"
            >
              <i class="fas fa-filter"></i>
              {{ $t("Filtros") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'weekly' ? 'active' : ''"
              @click="updateAnalytics('weekly')"
            >
              <i class="fas fa-calendar-week"></i>
              {{ $t("Weekly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'monthly' ? 'active' : ''"
              @click="updateAnalytics('monthly')"
            >
              <i class="fas fa-calendar-alt"></i>
              {{ $t("Monthly") }}
            </b-button>
            <b-button
              variant="outline-dark"
              :class="range === 'yearly' ? 'active' : ''"
              @click="updateAnalytics('yearly')"
            >
              <i class="fas fa-calendar"></i>
              {{ $t("Yearly") }}
            </b-button>
          </b-button-group>
        </div>
      </div>
      <filter-reports
        :report="report"
        @loadlist="getAnalytics"
        :showFilterReport="viewFilterReport"
        @hideFilter="viewFilters"
        :data_inicio="data_inicio"
        :data_fim="data_fim"
        @update:data_inicio="data_inicio = $event"
        @update:data_fim="data_fim = $event"
      ></filter-reports>
      <div class="col-md-12">
        <b-tabs content-class="mt-3">
          <b-tab
            title="Situações Prioritárias"
            active
            @click.prevent="changeTab('Situações Prioritárias')"
          >
            <div
              class="col-md-12"
              style="min-height: 700px"
              v-if="tabAtiva == 'Situações Prioritárias'"
            >
              <prioritarias-graph
                titulo="Situações Prioritárias"
                :loading="loading"
                :data="report.prioritarias"
                :range="range"
              />
            </div>
            <div class="col-md-12">
              <p class="text-muted small">
                Total de
                <b v-if="report.totalSituacoesPrioritarias"
                  >({{ report.totalSituacoesPrioritarias }})
                </b>
                Situações Prioritárias identificados nos Grupos do SCFV
              </p>
            </div>
          </b-tab>
          <b-tab
            title="Usuários Inscritos"
            @click.prevent="changeTab('Usuários Inscritos')"
          >
            <div class="row" v-if="graficoUsuarios">
              <div class="col-md-12" v-if="tabAtiva == 'Usuários Inscritos'">
                <grupos-graph
                  :loading="loading"
                  :data="report.usuarios"
                  :range="range"
                  titulo="Usuários Inscritos"
                  tipo="usuarios"
                />
                <p class="text-muted small">
                  Total de
                  <b v-if="report.totalUsers">({{ report.totalUsers }})</b>
                  Usuário(s) Inscrito(s) em Grupo(s) do SCFV
                </p>
              </div>
            </div>
          </b-tab>
          <b-tab title="Grupos" @click.prevent="changeTab('Grupos')">
            <div class="row" v-if="tabAtiva == 'Grupos'">
              <div class="col-md-12">
                <grupos-graph
                  :loading="loading"
                  :data="report.grupos"
                  :range="range"
                  :color="report.grupos[0].color"
                />
                <p class="text-muted small">
                  Total de
                  <b v-if="report.totalGrupos">({{ report.totalGrupos }}) </b>
                  Grupo(s) cadastrado(s) no SCFV
                </p>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="col-md-12 text-center">
        <p class="text-muted small">
          Importante: Os graficos de Usuários Inscritos e Grupos na ação de
          Filtros os dados retornados são agrupados com base no Ano inserido no
          campo <b>Data de início</b>.
        </p>
        <b-button
          :title="$t('Imprimir')"
          class="py-2"
          size="sm"
          type="button"
          v-b-tooltip.hover
          variant="primary"
          @click="printHtml()"
        >
          <i class="fas fa-print"></i>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "HomeSCFV",
  data() {
    return {
      loading: true,
      range: "yearly",
      graficoUsuarios: true,
      graficoGrupos: false,
      report: {
        prioritarias: [],
        grupos: [],
        usuarios: [],
        totalUsers: null,
        totalLinks: null,
        totalGrupos: null,
        totalDomains: null,
        datas: {
          start: "",
          end: "",
        },
      },
      tabAtiva: "Situações Prioritárias",
      filtros: {},
      data_inicio: "",
      data_fim: "",
    };
  },
  mounted() {
    this.getAnalytics();
  },
  methods: {
    changeTab(value) {
      if (value) {
        this.tabAtiva = value;
      } else {
        this.tabAtiva = "Situações Prioritárias";
      }
    },
    updateAnalytics(range) {
      if (this.range !== range) {
        this.range = range;
        this.getAnalytics();
      }
    },
    getAnalytics() {
      if (this.data_inicio) {
        this.filtros.data_inicial = this.$options.filters.formatDateYMD(
          this.data_inicio
        );
      }
      if (this.data_fim) {
        this.filtros.data_final = this.$options.filters.formatDateYMD(
          this.data_fim
        );
      }

      this.loading = true;
      axios
        .get("api/dashboard/report/scfv/home", {
          params: {
            range: this.range,
            filtros: this.filtros,
            grupo: this.grupo,
          },
        })
        .then((response) => {
          this.loading = false;
          this.report = response.data.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

